import React from 'react';
import MenuTagInPutBase from './MenuTagInPutBase';
import { useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { getUserListByProjectAtom } from '@/state/atom/userAtom';
import { listFormOfCorporationAtom, fieldListOfCorporationAtom } from '@/state/atom/formAtom';

export default function MenuTagInPutWithAuthen(props) {
    // common projectInuse state
    const projectDetail = useRecoilValue(projectInuseDetailAtom);
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    let userListOfProject = useRecoilValue(getUserListByProjectAtom);

   // common form field list
    const formsInCorporation = useRecoilValue(listFormOfCorporationAtom)
    const fieldsInCorporation = useRecoilValue(fieldListOfCorporationAtom)

    return (
        <MenuTagInPutBase
            {...props}
            projectDetail={projectDetail}
            isProjectManager={isProjectManager}
            userListOfProject={userListOfProject}
            formsInCorporation={formsInCorporation}
            fieldsInCorporation={fieldsInCorporation}
        />
    );
}
